// ResetPasswordModel.js
import { postData } from 'src/services/RestApi';

const resetPassword = async (form) => {
  const queryParams = {
    username: form.user,
    email: form.email,
    grant_type: 'reset_pass',
  };
  return await postData('auth/resetPassword/', queryParams);
};

export { resetPassword };
